import classNames from 'classnames';
import * as React from 'react';
import './style.css';

export interface PricingInfoProps
  extends React.ComponentPropsWithoutRef<'section'> {
  monthlyPrice: number;
}

export interface PricingInfoState {
  /* empty*/
}

export class PricingInfo extends React.Component<
  PricingInfoProps,
  PricingInfoState
> {
  render() {
    const { props } = this;

    return (
      <section className={classNames('premium-pricing-info', props.className)}>
        <h2>Subscribe to Edge of Play for</h2>
        <div className="premium-pricing-info__price-container">
          £{this.formattedPrice()} a month
        </div>
      </section>
    );
  }

  private formattedPrice = (): string => {
    const { monthlyPrice } = this.props;

    if (this.isIntegerPrice(monthlyPrice)) {
      return monthlyPrice.toFixed(0);
    }

    return monthlyPrice.toFixed(2);
  };

  private isIntegerPrice = (value: number): boolean => {
    return value % 1 < 0.01 / 2;
  };
}

export default PricingInfo;



// WEBPACK FOOTER //
// ./src/app/components/Premium/PremiumPage/PricingInfo/index.tsx